import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";

import Homepage2 from '../HomePage2'
import Projects, { getLegacyProjectPath, getProjectBySlug, getProjectPath } from '../../api/project'

const AboutPage = lazy(() => import('../AboutPage'));
const ServicePage = lazy(() => import('../ServicePage'));
const ServicePageS2 = lazy(() => import('../ServicePageS2'));
const ServiceSinglePage = lazy(() => import('../ServiceSinglePage'));
const ProjectPage = lazy(() => import('../ProjectPage'));
const ProjectPageS2 = lazy(() => import('../ProjectPageS2'));
const ProjectSinglePage = lazy(() => import('../ProjectSinglePage'));
const TeamSinglePage = lazy(() => import('../TeamSinglePage'));
const ManagementPage = lazy(() => import('../ManagementPage'));
const ManagementSinglePage = lazy(() => import('../ManagementSinglePage'));
const BlogPage = lazy(() => import('../BlogPage'));
const BlogPostPage = lazy(() => import('../BlogPostPage'));
const PricingPage = lazy(() => import('../PricingPage'));
const TestimonialPage = lazy(() => import('../TestimonialPage'));
const ContactPage = lazy(() => import('../ContactPage'));
const ShopPage = lazy(() => import('../ShopPage'));
const OrderRecived = lazy(() => import('../OrderRecived'));
const ProductSinglePage = lazy(() => import('../ProductSinglePage'));
const CartPage = lazy(() => import('../CartPage'));
const CheckoutPage = lazy(() => import('../CheckoutPage'));
const ErrorPage = lazy(() => import('../ErrorPage'));
const LoginPage = lazy(() => import('../LoginPage'));
const SignUpPage = lazy(() => import('../SignUpPage'));
const ForgotPassword = lazy(() => import('../ForgotPassword'));
const CompaniesPage = lazy(() => import('../CompaniesPage'));
const GigaBoutiqueMallPage = lazy(() => import('../GigaBoutiqueMallPage'));

const RouteFallback = () => <div style={{ minHeight: '100vh', background: '#0b0b0b' }} />;


const RedirectLegacyProject = () => {
  const { slug } = useParams();
  const { pathname } = useLocation();
  const project = getProjectBySlug(slug);
  const canonicalPath = project ? getProjectPath(project) : getLegacyProjectPath(slug);

  if (!canonicalPath) {
    return <ErrorPage />;
  }

  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  if (normalizedPath !== canonicalPath) {
    return <Navigate to={canonicalPath} replace />;
  }

  return <ProjectSinglePage project={project} />;
};

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route exact path='/' element={<Homepage2/>} />
          <Route path='home' element={<Homepage2/>} />
          {/* <Route path='home2' element={<Homepage2/>} /> */}
          {/* <Route path='home3' element={<Homepage3/>} /> */}
          {/* <Route path='home4' element={<Homepage4/>} /> */}
          {/* <Route path='home5' element={<Homepage5/>} /> */}
          <Route path='about-us' element={<AboutPage/>} />
          {Projects.map((project) => (
            <Route
              key={project.slug}
              path={`project/${project.slug}`}
              element={<ProjectSinglePage project={project} />}
            />
          ))}
          <Route path='project/:slug' element={<RedirectLegacyProject/>} />
          <Route path='project/:slug/' element={<RedirectLegacyProject/>} />
          <Route path='project-single' element={<Navigate to="/project/goldcrest-views" replace />} />
          <Route path='project-single/:slug' element={<RedirectLegacyProject/>} />
          <Route path='project-single/:slug/' element={<RedirectLegacyProject/>} />
          <Route path='service-single/:id' element={<ServiceSinglePage/>} />
          <Route path='team-single/:id' element={<TeamSinglePage/>} />
          <Route path='management' element={<ManagementPage/>} />
          <Route path='management-single/:id' element={<ManagementSinglePage/>} />
          <Route path='service' element={<ServicePage/>} />
          <Route path='service-s2' element={<ServicePageS2/>} />
          <Route path='projects' element={<ProjectPage/>} />
          <Route path='project-s2' element={<ProjectPageS2/>} />
          <Route path='pricing' element={<PricingPage/>} />
          <Route path='testimonial' element={<TestimonialPage/>} />
          <Route path='celebrity-testimonials' element={<TestimonialPage/>} />
          <Route path='shop' element={<ShopPage/>} />
          <Route path='product-single/:id' element={<ProductSinglePage/>} />
          <Route path='cart' element={<CartPage/>} />
          <Route path='checkout' element={<CheckoutPage/>} />
          <Route path='order_received' element={<OrderRecived/>} />
          <Route path='contact-us' element={<ContactPage/>} />
          <Route path='companies' element={<CompaniesPage/>} />
          <Route path='giga-boutique-mall' element={<GigaBoutiqueMallPage/>} />
          <Route path='blog/:slug' element={<BlogPostPage/>} />
          <Route path='blog' element={<BlogPage/>} />
          <Route path='404' element={<ErrorPage/>} />
          <Route path='login' element={<LoginPage/>} />
          <Route path='register' element={<SignUpPage/>} />
          <Route path='forgot-password' element={<ForgotPassword/>} />
          <Route path="*" element={<ErrorPage/>} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
